import logger from '@/modules/Logger';
import {
  BUFFER_SWITCH_DOWNGRADE_COUNT,
  BUFFER_SWITCH_UPGRADE_COUNT
} from '@/modules/webrtc/agora/const';

let newUplinkQuality = {};

export default {
  async setQualityOnUpLinkSpeed(quality) {
    newUplinkQuality = this.setQualityOfNetwork(quality);

    if (this.upLinkNetworkQuality === newUplinkQuality.value) {
      return;
    }

    if (this.shouldApplyBufferSwitchOnUplink()) {
      this.switchUpLinkBuffer.push(newUplinkQuality.value);
      return;
    }

    await this.setSendStreamQuality(newUplinkQuality);
  },

  async setSendStreamQuality(newUplinkQuality) {
    this.switchUpLinkBuffer = [];
    this.upLinkNetworkQuality = newUplinkQuality.value;

    logger.info('[Agora] Uplink network changes, switch send stream quality', {
      operation: 'webrtc:call-quality',
      quality: newUplinkQuality.label
    });

    try {
      // set local video stream resolution
      await this.localVideoTrack?.setEncoderConfiguration(newUplinkQuality.profile);

      // enable or disable dual stream based on network quality
      await this.updateDualStreamQuality();
    } catch (error) {
      logger.error('[Agora] Error while setting send stream quality', {
        operation: 'webrtc:call-quality',
        error: error.message,
        event_type: 52,
        lesson_id: this.lessonId
      });
    }
  },

  async updateDualStreamQuality() {
    this.isUpLinkExcellentQuality()
      ? await this.rtc.enableDualStream()
      : await this.rtc.disableDualStream();
  },

  /*
   * Apply asymmetric buffering to minimize frequent switching.
   * Downgrade (quality deteriorating, higher numeric value): triggers after BUFFER_SWITCH_DOWNGRADE_COUNT (3)
   * Upgrade (quality improving, lower numeric value): triggers after BUFFER_SWITCH_UPGRADE_COUNT (6)
   * Buffer resets to empty after each triggered switch.
   */
  shouldApplyBufferSwitchOnUplink() {
    const isDowngrade = newUplinkQuality.value > this.upLinkNetworkQuality;
    const bufferThreshold = isDowngrade
      ? BUFFER_SWITCH_DOWNGRADE_COUNT
      : BUFFER_SWITCH_UPGRADE_COUNT;

    return this.switchUpLinkBuffer.length < bufferThreshold;
  }
};
